module.exports = "<base-chart class=\"m-t-20 m-b-25 char\" [data]=\"pieChartData\" [labels]=\"pieChartLabels\" [chartType]=\"pieChartType\" [options]=\"pieChartOptions\"></base-chart>";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounting/shared/ui/pie-chart/pie-chart.component.pug
// module id = 864
// module chunks = 0